export function loadingStart() {
  document.body.classList.add("page-loading");
  window.autoChangeTimer = false;
  headerAnimation();
  let loadingScreenContainer = document.getElementById("loading-screen");
  if (loadingScreenContainer) {
    return;
  }

  document.body.classList.add("page-loading");

  loadingScreenContainer = document.createElement("div");
  loadingScreenContainer.setAttribute("id", "loading-screen");

  let logoContainer = document.createElement("div");
  logoContainer.classList.add("loading-screen__logo");
  loadingScreenContainer.appendChild(logoContainer);

  document.body.appendChild(loadingScreenContainer);
}

export function loadingEnd() {
  let loadingScreenContainer = document.getElementById("loading-screen");

  setTimeout(() => {
    document.body.classList.add("page-loading--hide");
    document.body.classList.remove("page-loading");
  }, 100);

  setTimeout(() => {
    document.body.classList.remove("page-loading--hide");
    loadingScreenContainer.remove();
    $.post("/preloading", { preloading: 1 });
  }, 1900);
}

function headerAnimation() {
  const animationTime = 3000;
  const animationTimeDelay = 100;
  const animationClass = "loading__carousel--animation";
  const animationElement =
    document.getElementsByClassName("loading__carousel")[0];

  if (!animationElement) {
    return false;
  }

  const $firstElement = animationElement.children[0];
  animationElement.appendChild($firstElement.cloneNode(true));

  animationTimer(
    animationTime,
    animationTimeDelay,
    window.autoChangeTimer,
    animationElement,
    animationClass
  );
}

function animationTimer(
  animationTime,
  animationTimeDelay,
  autoChangeTimer,
  animationElement,
  animationClass
) {
  clearTimeout(autoChangeTimer);
  let timer = setTimeout(() => {
    animationElement.classList.remove(animationClass);
    setTimeout(() => {
      animationElement.classList.add(animationClass);

      setTimeout(() => {
        animationTimer(
          animationTime,
          animationTimeDelay,
          autoChangeTimer,
          animationElement,
          animationClass
        );
      }, 0);
    }, animationTimeDelay);
  }, animationTime);
  return timer;
}
